/**
 * Formata um valor em Real (BRL). Retorna `null` quando o valor é `null`/`undefined` — cada
 * chamador decide o placeholder (`'—'`, ocultar o elemento, etc). `options` permite variações
 * pontuais (ex: `{ maximumFractionDigits: 0 }` nos KPIs do relatório, sem casas decimais).
 */
export function formatMoeda(valor: number | null | undefined, options?: Intl.NumberFormatOptions): string | null {
  if (valor === null || valor === undefined) return null;
  return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', ...options });
}
